import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  BulkCommentInput,
  BulkCommentsOperationResult,
} from '@investigator/shared/generated/graphql';

export interface CreateBulkCommentsForDetectionsVariables {
  comment: BulkCommentInput;
}

export interface CreateBulkCommentsForDetectionsResponse {
  createBulkCommentsForDetections: BulkCommentsOperationResult;
}

export const CREATE_BULK_COMMENTS_FOR_DETECTIONS = gql`
  mutation createBulkCommentsForDetections($comment: BulkCommentInput!) {
    createBulkCommentsForDetections(comment: $comment) {
      message
    }
  }
`;

export const useCreateBulkCommentsForDetections = (
  options?: MutationHookOptions<
    CreateBulkCommentsForDetectionsResponse,
    CreateBulkCommentsForDetectionsVariables
  >,
) => {
  return useMutation<
    CreateBulkCommentsForDetectionsResponse,
    CreateBulkCommentsForDetectionsVariables
  >(CREATE_BULK_COMMENTS_FOR_DETECTIONS, options);
};
